/** Texas bbox for Mapbox: [minLon, minLat, maxLon, maxLat] = [W, S, E, N]. */
export const TEXAS_BBOX = [-106.65, 25.84, -93.48, 36.49];

/** Houston-ish bias point for autocomplete ranking. */
export const TEXAS_PROXIMITY = { longitude: -95.3698, latitude: 29.7604 };

/**
 * Keep only Texas places. Do not use a rectangular center-in-bbox check:
 * that box overlaps southern OK/NM/LA/AR (e.g. Dewey County, OK).
 * Require an explicit Texas region/code or place_name.
 */
export function isTexasGeocoderFeature(feature = {}) {
  if (feature.properties?.short_code === "US-TX") return true;

  const context = feature.context || [];
  for (const entry of context) {
    if (entry?.short_code === "US-TX") return true;
    if (isTexasRegionEntry(entry)) return true;
  }

  return placeNameIsTexas(feature.place_name);
}

function isTexasRegionEntry(entry) {
  return (
    typeof entry?.id === "string" &&
    entry.id.startsWith("region.") &&
    String(entry.text || "").toLowerCase() === "texas"
  );
}

function placeNameIsTexas(placeNameValue) {
  const placeName = String(placeNameValue || "").toLowerCase();
  return (
    placeName.includes(", texas,") ||
    placeName.endsWith(", texas") ||
    placeName.includes(", tx,") ||
    placeName.endsWith(", tx")
  );
}
